import { analytics } from '@features/analytics';

type CapturePoint = 'registration' | 'billing';

const storageKey = (basketId: string) => `email_captured:${basketId}`;

export const hasCapturedEmail = (basketId: string): boolean => {
  try {
    return sessionStorage.getItem(storageKey(basketId)) === '1';
  } catch {
    return false;
  }
};

const markCaptured = (basketId: string): void => {
  try {
    sessionStorage.setItem(storageKey(basketId), '1');
  } catch {
    return;
  }
};

export const trackEmailCaptured = (basketId: string, capturePoint: CapturePoint): void => {
  if (hasCapturedEmail(basketId)) {
    return;
  }

  markCaptured(basketId);

  analytics.track({
    event: 'email_captured',
    params: {
      basket_id: basketId,
      capture_point: capturePoint,
    },
  });
};
